<template>
  <div>
    <layout-panel :collapse="collapse">
      <span slot="header">冲销信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 1000px">
            <el-form-item label="待冲销金额：">
              <el-row :gutter="20">
                <el-col :span="4">
                  <span>￥{{form.wait_write_off | seperateThousandsToFixed(2)}}</span>
                </el-col>
                <el-col :span="6">
                  <span>已付金额：￥{{form.paid_amount_total | seperateThousandsToFixed(2)}}</span>
                </el-col>
                <el-col :span="6">
                  <span>已冲销金额：￥{{form.written_off_amount | seperateThousandsToFixed(2)}}</span>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <h3>冲销记录：{{form.wait_write_off ? '' : '暂无'}}</h3>

      <template v-if="form.write_off_lists.length > 0">
        <el-form v-for="(item, index) in form.write_off_lists" :key="index" ref="form"
                 :model="form"
                 size="medium"
                 style="margin-left: 20px"
                 label-width="140px">
          <h4>冲销申请状态：<span :style="writeoffStatusStyle(item.status)">{{item.status_name}}</span></h4>
          <h4 style="margin-bottom: 20px;">{{item.write_off_at | formatExpectedDate}} {{item.admin_name}} 冲销 ￥{{item.amount | seperateThousandsToFixed(2)}}</h4>
          <el-row :gutter="20" style="margin-left: 0px">
            <el-col :span="1" class="col-center">序号</el-col>
            <el-col :span="2" class="col-center">项目编号</el-col>
            <el-col :span="3" class="col-center">费用承担部门</el-col>
            <el-col :span="3" class="col-center">一级科目</el-col>
            <el-col :span="3" class="col-center">二级科目</el-col>
            <el-col :span="2" class="col-center">发票类型</el-col>
            <el-col :span="2" class="col-center">税率</el-col>
            <el-col :span="2" class="col-center">含税冲销金额</el-col>
            <el-col :span="2" class="col-center">发票张数</el-col>
            <el-col :span="2" class="col-center">摘要</el-col>
          </el-row>
          <br/>

          <el-row :gutter="20" v-for="(detailItem, itemIndex) in item.write_off_detail.filter(item => !item.is_zero_apply)"
                  :key="itemIndex"
                  class="invoice-row"
                  style="margin-top:5px">
            <!--序号-->
            <el-col style="text-align: center" :span="1">
              {{itemIndex+1}}
            </el-col>
            <!-- 项目编号 -->
            <el-col key="project_id"
                    :span="2">
              <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
            </el-col>
            <!-- 费用承担部门 -->
            <el-col key="department_name"
                    :span="3">
              <span>{{detailItem.department_name}}</span>
            </el-col>

            <!--一级科目-->
            <el-col :span="3">
              <span>{{detailItem.first_subject_name}}</span>
            </el-col>
            <!--二级科目-->
            <el-col :span="3">
              <span>{{detailItem.second_subject_name}}</span>
            </el-col>
            <!--发票类型-->
            <el-col :span="2">
              <span>{{detailItem.invoice_type_name}}</span>
            </el-col>
            <!--税率-->
            <el-col :span="2" style="text-align:center;overflow: auto;">
              <span>{{ detailItem.invoice_type === 1 ? '-' : (taxRateType[detailItem.tax_rate] || (detailItem.tax_rate + '%')) }}</span>
            </el-col>
            <!--含税金额-->
            <el-col :span="2" style="text-align:center;overflow: auto;">
              <span>￥{{detailItem.amount | seperateThousandsToFixed(2)}}</span>
            </el-col>
            <!--发票张数-->
            <el-col :span="2">
              <span>{{detailItem.invoice_count}}</span>
            </el-col>
            <!--摘要-->
            <el-col :span="2">
              <span style="word-break: break-all;">{{detailItem.desc}}</span>
            </el-col>
          </el-row>
          <br/>
          <el-form-item label="核销说明："
                        prop="desc">
              <span>{{item.desc}}</span>
          </el-form-item>
          <el-form-item label="附件："
                        prop="attached_file">
            <AttachedFileContent :files="item.attached_file"/>
          </el-form-item>
          <el-form-item label="审批人：" v-if="form.paid_to_type === 1">
            <p v-if="item.approve_level > 0" style="white-space:pre-wrap;">部门领导审批：{{`${item.department_approver_name}/${item.department_approver_real_name || '-'}`}}</p>
            <p v-if="item.approve_level > 0" style="white-space:pre-wrap;">一级审批：{{`${item.first_approver_name}/${item.first_approver_real_name || '-'}`}}</p>
            <p v-if="item.approve_level > 1" style="white-space:pre-wrap;">二级审批：{{`${item.second_approver_name}/${item.second_approver_real_name || '-'}`}}</p>
            <p v-if="item.approve_level > 2" style="white-space:pre-wrap;">三级审批：{{`${item.third_approver_name}/${item.third_approver_real_name || '-'}`}}</p>
            <p v-if="item.approve_level > 3" style="white-space:pre-wrap;">四级审批：{{`${item.fourth_approver_name}/${item.fourth_approver_real_name || '-'}`}}</p>
          </el-form-item>
          <el-form-item label="抄送人：">
            <p style="white-space:pre-wrap;">{{ item.cc_list | ccname }}</p>
          </el-form-item>
          <el-form-item label="冲销日志："
                        prop="log">
              <span style="white-space:pre-wrap;">{{writeOffLogFrom(item.log)}}</span>
          </el-form-item>
        </el-form>
      </template>

    </layout-panel>
  </div>
</template>

<script>
import AttachedFileContent from '@/views/payment-manager/components/AttachedFileContent'
export default {
  components: {
    AttachedFileContent
  },
  filters: {
    formatExpectedDate (date) {
      if (moment(date).isValid()) {
        return moment(date).format('YYYY-MM-DD')
      }
      return ''
    },
    ccname (list) {
      if (list) {
        return list.map(item => `${item.name}/${item.name || '-'}`).join('\n')
      }
      return '无'
    }
  },
  props: {
    form: {
      type: Object,
      required: true,
      default: () => {}
    },
    collapse: {
      type: Boolean,
      default: false
    },
    projectNames: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...Vuex.mapState({
      invoiceType: state => state.paymentManagerNew.invoiceType,
      taxRateType: state => state.paymentManagerNew.taxRateType,
    }),
  },
  methods: {
    writeOffLogFrom (logs) {
      return logs.reduce((total, item) => {
        return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
      }, '')
    },
    writeoffStatusStyle (status) {
      if ([8].includes(status)) {
        return {color: '#67C23A'}
      } else if ([9].includes(status)) {
        return {color: '#F56C6C'}
      }
      return {color: '#303133'}
    },
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
p {
  margin: 0;
  padding: 0;
}
.col-center {
  text-align:center
}
.invoice-row .el-col {
  line-height: 30px;
  text-align: center;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>


// WEBPACK FOOTER //
// src/views/payment-manager-new/components/PaymentWriteOffInfo.vue